<wl-content-section [theme]="theme()">
  <wl-content-single-column-text-section
    [heading]="rendering().fields?.heading"
    [richText]="rendering().fields?.richText"
  >
    @if (showAppStoreButtons()) {
      <wl-app-store-buttons
        app-store-buttons
        [appStoreButtonLink]="appStoreButton()"
        [googlePlayButtonLink]="googlePlayButton()"
      />
    }
    @if (showCallToActionButton()) {
      <div class="d-flex" call-to-action-button>
        <crnt-button-alt class="flex-grow-1 flex-md-grow-0" variant="secondary">
          <a *wlGenericLink="rendering().fields?.callToActionButtonLink"></a>
        </crnt-button-alt>
      </div>
    }
  </wl-content-single-column-text-section>
</wl-content-section>
